import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

export const SolarPower = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ color = 'white', width = '24', height = '24', ...props }, ref) => {
    return (
      <SvgIcon
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 19 18"
        sx={{
          backgroundColor: (theme) => theme.palette.badge['moss-green'],
          borderRadius: 4,
          padding: '2px',
          width,
          height,
        }}
        {...props}
      >
        <g id="fi:sun" clipPath="url(#clip0_599_8607)">
          <path
            id="Vector"
            d="M9.3335 15.5625V17.0208"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M13.9712 13.6375L15.0066 14.6729"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M3.65967 14.6731L4.69508 13.6377"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M15.896 9H17.3543"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_5"
            d="M1.31299 9H2.77132"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_6"
            d="M9.33382 12.6459C11.3474 12.6459 12.9797 11.0136 12.9797 9.00008C12.9797 6.98654 11.3474 5.35425 9.33382 5.35425C7.32028 5.35425 5.68799 6.98654 5.68799 9.00008C5.68799 11.0136 7.32028 12.6459 9.33382 12.6459Z"
            fill={color}
            stroke={color}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_7"
            d="M13.9712 4.36257L15.0066 3.32715"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_8"
            d="M3.65967 3.3269L4.69508 4.36232"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_9"
            d="M9.3335 0.979248V2.43758"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_599_8607">
            <rect width="17.5" height="17.5" fill={color} transform="translate(0.583496 0.25)" />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  }
);
